
/**
 * Accordion
 *
 */
// TOP NEWS
{
  const newsAccordion = document.querySelectorAll(".js-newsAccordion");

  newsAccordion.forEach(accordion => {
    const dtElements = accordion.querySelectorAll("dt");

    dtElements.forEach(dt => {
      dt.addEventListener("click", function () {
        const content = this.nextElementSibling.querySelector(".news__content");

        if (content) {
          content.classList.toggle("is-open"); 
          this.parentElement.classList.toggle("is-open");
        }
      });
    });
  });
}
// {
//   const newsAccordion = document.querySelectorAll(".js-newsAccordion");
//   newsAccordion.forEach(accordion => {
//     const dtElements = accordion.querySelectorAll("dt");
//     dtElements.forEach(dt => {
//       dt.addEventListener('click', function () {
//         const content = this.parentElement.querySelector(".news__content");
//         if (content) {
//           content.style.display = content.style.display === 'none' ? 'block' : 'none';
//         }
//         this.parentElement.classList.toggle("is-open");
//       });
//     });
//   });
// }
// 

// FAQ
{
  const faqAccordion = document.querySelectorAll(".js-faqAccordion");

  faqAccordion.forEach(accordion => {
    const trigger = accordion.querySelector(".guideItem__header");
  
    trigger.addEventListener("click", function () {
      accordion.classList.toggle("is-open");
    });
  });
}
// FAQ SP
{
  const menu = document.getElementById("guide_toc_menu");

    if (menu) {
      menu.addEventListener("change", function () {
        const value = this.value;
        if (value) {
          const target = document.querySelector(value);
          if (target) {
            target.scrollIntoView({ behavior: "smooth" });
          }
        }
      });
    }
}
/**
 * Swiper
 *
 */
{
  const sliders = document.querySelectorAll(".js-topslider");
  sliders.forEach(slider => {
    const mvSlider = new Swiper(slider, {
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 4000,
      },
      navigation: {
        nextEl: '.p-slider-button__next',
        prevEl: '.p-slider-button__prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // fadeEffect: {
      //   crossFade: true
      // },
    })
  })
}
